import React from 'react';
import GavelRoundedIcon from '@mui/icons-material/GavelRounded';
import PublicPage, { COMPANY, SUPPORT_EMAIL } from './PublicPage';

// Public terms of use (linked from the Zoom Marketplace listing).
const Terms = () => (
  <PublicPage title="Terms of Use" updated="5 October 2026" icon={<GavelRoundedIcon sx={{ fontSize: 40, color: '#38bdf8' }} />}>
    <p>
      These terms apply to ZPro Audio — the Android app, the Windows app and the web panel at zt.zaudio.us — provided by
      <strong> {COMPANY}</strong> ("we", "us"). By using ZPro Audio you agree to them.
    </p>

    <h2>1. The service</h2>
    <p>
      ZPro Audio runs hold-to-talk audio rooms on top of Zoom meetings. Organisations buy access for a period; their admin creates
      hosts, participants and rooms in the web panel and connects the organisation's own Zoom account with "Connect Zoom".
    </p>

    <h2>2. Accounts</h2>
    <ul>
      <li>Accounts are created by the organisation's admin. Keep your password private; you are responsible for activity on your account.</li>
      <li>A participant account works on one phone at a time. Access ends when the account's expiry date passes or the admin deactivates or deletes it.</li>
      <li>The admin is responsible for the information entered about hosts and participants and for having the right to enter it.</li>
    </ul>

    <h2>3. Zoom</h2>
    <p>
      Meetings run on the organisation's Zoom account, so Zoom's own terms and privacy statement also apply. Features such as cloud
      recording depend on the organisation's Zoom plan. Removing ZPro Audio from the Zoom account, or clicking Disconnect in the panel,
      stops new meetings from starting.
    </p>

    <h2>4. Acceptable use</h2>
    <ul>
      <li>Do not use ZPro Audio for anything unlawful, abusive or harassing.</li>
      <li>Recording: if you record meetings (Zoom cloud recording or the Windows app's backup recording), you must tell everyone in the meeting, and get any consent the law requires.</li>
      <li>Do not try to break, overload or get around the security of the service, or access accounts that are not yours.</li>
    </ul>

    <h2>5. Fees</h2>
    <p>Prices, periods and payment are agreed between us and the organisation. Unpaid or expired accounts are switched off.</p>

    <h2>6. Availability and changes</h2>
    <p>
      We work to keep ZPro Audio available but cannot promise it will always be uninterrupted or error-free, and it depends on Zoom's
      service. We may update or change features; we will tell admins in advance about changes that remove features they use.
    </p>

    <h2>7. Disclaimer and liability</h2>
    <p>
      ZPro Audio is provided "as is". To the extent the law allows, we are not liable for indirect or consequential losses, and our total
      liability for any claim is limited to the fees the organisation paid us in the 3 months before the claim.
    </p>

    <h2>8. Ending use</h2>
    <p>
      An organisation can stop using ZPro Audio at any time by disconnecting Zoom and asking us to close its accounts. We may suspend
      accounts that break these terms.
    </p>

    <h2>9. Contact</h2>
    <p>Questions about these terms: <a href={'mailto:' + SUPPORT_EMAIL}>{SUPPORT_EMAIL}</a>.</p>
  </PublicPage>
);

export default Terms;
